// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRODUCT_CHOOSE_CURREN_PRODUCT_MODEL,
} from './constants';

export function chooseCurrenProductModel(model) {
  return {
    type: PRODUCT_CHOOSE_CURREN_PRODUCT_MODEL,
    data:model
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRODUCT_CHOOSE_CURREN_PRODUCT_MODEL:
      return {
        ...state,
        chooseState_show:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/product/redux/chooseCurrenProductModel.js